import { MemberInterface } from "@swivl-mono/types";
import { Button, ButtonColor, ButtonSize, ButtonVariant } from "@swivl-mono/ui";
import { FC } from "react";
import { TiDelete } from "react-icons/ti";

interface Props {
  value: MemberInterface;
  onDelete: (memberId: number) => void;
}

export function getAgentName({ agentName, account }: MemberInterface) {
  if (agentName) {
    return agentName;
  }
  if (account) {
    const { firstName, lastName } = account;
    return [firstName, lastName].filter(Boolean).join(" ");
  }
  return "Unknown agent";
}

export const MembersListItem: FC<Props> = ({ value, onDelete }) => {
  return (
    <div className="flex w-[300px] min-h-fit py-2.5 px-3 border border-grey-400 rounded-[5px] bg-grey-100 group">
      <span className="flex-1">{getAgentName(value)}</span>
      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        <Button
          onClick={() => onDelete(value.id)}
          size={ButtonSize.SMALL}
          color={ButtonColor.WHITE}
          variant={ButtonVariant.ICON}
        >
          <TiDelete size="24px" color="rgba(255, 75, 52, 1)" />
        </Button>
      </div>
    </div>
  );
};
